import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { validateState, VALIDATION_EMPTY_FIELD } from '../useForm/validate';
import { useValidateState } from '../useValidateState';

export const useValidateField = (defaultValue, required = false) => {
    const { t: translate } = useTranslation();
    const [errorText, changeError] = useValidateState({}, defaultValue, required, translate);

    useEffect(() => {
        changeError((validateState({}, defaultValue, required, translate) || {}).errorText);
    }, [defaultValue, translate]);

    return {
        isError: Boolean(errorText),
        errorText: errorText === translate(VALIDATION_EMPTY_FIELD) ? ' ' : errorText,
    };
};
